import React from "react";
import TableChangeLogs from "../../components/ChangeLogs/TableChangeLogs/TableChangeLogs";

const ChangeLogs = (props) => {
  return (
    <div>
      <TableChangeLogs />
    </div>
  );
};

export default ChangeLogs;
